import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NEAR_BLACK, LOW_BLUE, NEAR_WHITE } from "../../config/colors";

export const ModalBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const CloseOption = styled.div`
  width: fit-content;
  height: fit-content;
  padding: inherit;
  float: right;
  padding: 0px;
`;

export const CloseModal = styled(FontAwesomeIcon)`
  cursor: pointer;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100%;
`;

export const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: NEAR_BLACK,
    border: "none",
    borderRadius: "1rem",
    padding: "0",
    width: "900px",
    height: "550px",
    justifyContent: "space-between",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
    zIndex: 5,
  },
};

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px ${NEAR_WHITE} solid;
  padding: 30px;
  padding-bottom: 20px;
  align-items: center;
  color: ${NEAR_WHITE};
`;

export const ModalFooter = styled.div`
  bottom: 0px;
  position: fixed;
  width: 100%;
`;

export const ModalImg = styled.img`
  object-fit: cover;
  width: 40%;
`;

export const TextModal = styled.div`
  display: flex;
  color: ${NEAR_WHITE};
  padding: 0rem 1rem;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  text-align: initial;
  width: 60%;
  flex-direction: column;
`;

export const Title = styled.h2`
  text-align: center;
  color: ${NEAR_WHITE};
  margin: 0px;
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SubTitle = styled.span`
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: ${LOW_BLUE};
  margin-bottom: 15px;
`;
